import React from 'react';
import { Box, FormControl, Select, MenuItem, Typography } from '@mui/material';

/**
 * The app's "Sort by" box: sits beside a search field (search ~2/3, this ~1/3) and shows
 * "Sort by" above the chosen option, like the one on the Customers page.
 *
 * value     the chosen option's value
 * onChange  (value) => void
 * options   [{ value, label, short }] — label in the menu, short in the box ("Added ↓")
 * sx        merged onto the FormControl (width etc.)
 */
export default function SortSelect({ value, onChange, options, sx = {} }) {
    const isDefault = value === options[0]?.value;
    return (
        <FormControl size="small" sx={{ flexShrink: 0, width: 'calc(34% - 8px)', ...sx }}>
            <Select
                value={value}
                onChange={(e) => onChange(e.target.value)}
                renderValue={(v) => {
                    const o = options.find(x => x.value === v);
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1, minWidth: 0 }}>
                            <Typography variant="caption" sx={{ fontSize: '0.65rem', color: 'text.disabled', lineHeight: 1 }}>Sort by</Typography>
                            <Typography variant="body2" noWrap sx={{ fontSize: '0.82rem', fontWeight: 600, color: 'text.primary', lineHeight: 1.3 }}>
                                {o ? (o.short || o.label) : v}
                            </Typography>
                        </Box>
                    );
                }}
                sx={{
                    // A sort other than the default is outlined in blue, so it's never applied unnoticed.
                    '& .MuiOutlinedInput-notchedOutline': isDefault ? {} : { borderColor: 'primary.main', borderWidth: 1.5 },
                    '& .MuiSelect-select': { py: '4px' },
                }}
            >
                {options.map(o => <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>)}
            </Select>
        </FormControl>
    );
}
